import React from 'react'
import { Link } from 'react-router-dom'
import { GridCell } from '@progress/kendo-react-grid'
import { Column } from '@/components/BsrsGrid'

const LinkCell = ({ urlFormatter, linkText }) => {
  return class LinkGridCell extends GridCell {
    render () {
      const url = urlFormatter(this.props.dataItem)
      return (<td><Link to={url} target='_blank'>{linkText}</Link></td>)
    }
  }
}

export default ({ urlFormatter, linkText, ...props }) => {
  return <Column
    cell={LinkCell({ urlFormatter, linkText })}
    {...props} />
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/linkColumn.js